module.exports = __webpack_public_path__ + "static/awards-icon-3-0d523c7b0e8eae8479bcf6655e535315.png";